// extracted by mini-css-extract-plugin
export var colorSquare = "_tu-0";
export var danger = "_tu-5";
export var lightPink = "_tu-8";
export var neutralBlue = "_tu-7";
export var neutralYellow = "_tu-6";
export var normal = "_tu-1";
export var primary = "_tu-2";
export var primaryLight = "_tu-3";
export var solidBlack = "_tu-g";
export var solidGreen = "_tu-b";
export var solidLightBlue = "_tu-d";
export var solidNavy = "_tu-c";
export var solidOrange = "_tu-f";
export var solidPink = "_tu-e";
export var solidRed = "_tu-9";
export var solidYellow = "_tu-a";
export var success = "_tu-4";